module.exports = "/_next/static/images/4200ca0f464f66e079b26614cf10b447-mockup-transfer@1x.jpg";